import { siteStats } from "@/mocks/guaData";

export default function HomeStats() {
  return (
    <section className="w-full border-b border-background-200 bg-background-50" aria-label="站点数据">
      <div className="mx-auto grid w-full max-w-[1440px] grid-cols-2 gap-px overflow-hidden rounded-none bg-background-200 px-0 md:grid-cols-4">
        {siteStats.map((stat) => (
          <div key={stat.label} className="flex items-center gap-3 bg-background-50 px-4 py-5 md:px-8 md:py-6">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
              <i className={`${stat.icon} text-xl leading-none`} aria-hidden="true" />
            </span>
            <span className="flex flex-col">
              <span className="heading-font text-lg font-black text-foreground-950 md:text-xl">{stat.value}</span>
              <span className="text-xs text-foreground-500">{stat.label}</span>
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}